'use strict';

/** creatyBy LiangY
 *   Module  幻灯片模板
 *
 * Description
 */
angular.module('util.trsSliderModule', []).directive('trsSlider', ['$timeout', '$window', 'sensitiveWordCheckService', function($timeout, $window, sensitiveWordCheckService) {
    // Runs during compile
    return {
        replace: false,
        scope: {
            sliderPic: '=', // 内容信息
            parentWidth: '=',
            thumbWidth: '@', // 自定义底部缩略图宽度
            useChannel: '@', // 定义使用渠道，个渠道的数据返回不同
            bigPicture: '@', // 大图字段（为了兼容之前，保留之前的字段为默认字段）
            thumbnail: '@', // 缩略图字段
            callback: '&', // 每一次切换时要执行的回调
        },
        restrict: 'AE',
        templateUrl: './components/util/trsSlider/slider_tpl.html',
        link: function(scope, iElm, iAttrs, controller) {
            var checkSensitiveWord = iElm.attr('checksensitiveword'); // 图说是否校验敏感词
            $timeout(function() {
                scope.len = scope.sliderPic.length;
                init();
            }, 500);

            function init() {
                scope.status = {
                    innerwidth: 0,
                    singleWidth: 0,
                };
                scope.status.singleWidth = !!scope.thumbWidth ? (parseInt(scope.thumbWidth) + 10) : (153 + 10); // //每个小图标所占宽度
                var picNum = (iElm.find('.carousel-footer-inner').width() + 10) / scope.status.singleWidth;
                scope.moveNum = parseInt(picNum);
                scope.thumbNum = parseInt(picNum);
                scope.status.innerwidth = scope.len * scope.status.singleWidth - 10; // 所有小图所占的总宽度  
            }

            scope.convertFormat = function(slide) {
                var tm = scope.useChannel;
                var imgDesc = !scope.useChannel ? slide.APPDESC : slide[tm];
                imgDesc.replace(/\n/g, '<br/>');
                if (angular.isDefined(checkSensitiveWord)) {
                    sensitiveWordCheckService.checkAndMarkSensitiveWord(imgDesc).then(function(checkedWords) {
                        imgDesc = checkedWords;
                    });
                }
                if (!scope.useChannel) {
                    slide.APPDESC = imgDesc;
                } else {
                    slide[tm] = imgDesc;
                }
            };
            scope.openOriginalPic = function(url) {
                $window.open(url); // op
            };
            // 小图标点击向左滚动
            scope.toLeft = function() {
                var $imgDiv = iElm.find('.carousel-footer-inner');
                var scrollLeft = $imgDiv.scrollLeft();
                $imgDiv.animate({ scrollLeft: scrollLeft -= (scope.moveNum * scope.status.singleWidth) }, 1000, 'swing');
            };
            // 小图标点击向右滚动
            scope.toRight = function() {
                var $imgDiv = iElm.find('.carousel-footer-inner');
                var scrollLeft = $imgDiv.scrollLeft();
                $imgDiv.animate({ scrollLeft: scrollLeft += (scope.moveNum * scope.status.singleWidth) }, 1000, 'swing');
            };
            scope.$on('sliderSlide', function(event, data) {
                var $lis = $('.carousel-footer-inner').find('li');
                var $li = $lis.eq(scope.curSliderIndex);
                var $imgDiv = $('.carousel-footer-inner');
                var left = $li.offset().left;
                if (scope.curSliderIndex === 0) {
                    $imgDiv.animate({ scrollLeft: 0 }, 500);
                } else if (scope.curSliderIndex === ($lis.length - 1)) {
                    $imgDiv.animate({ scrollLeft: scope.status.innerwidth }, 500);
                } else if (left > 1020) {
                    scope.toRight();
                } else if (left < 255) {
                    scope.toLeft();
                }
            });
            scope.$on('sliderIndex', function(event, data) {
                if (scope.callback && angular.isFunction(scope.callback)) {
                    scope.callback()(data);
                }
                scope.curSliderIndex = data;
            });
        },
    };
}]);
